document.addEventListener("DOMContentLoaded", () => {
  // Only run if viewport width is below 768px
  if (window.matchMedia("(max-width: 767px)").matches) {
    const observer = new MutationObserver(() => {
      const submitButton = document.querySelector(".globo-form-id-127964 .wizard__footer button");
      if (submitButton && submitButton.textContent !== "Contact the Manager") {
        submitButton.textContent = "Contact the Manager";
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});
